<script setup>
import { ref, watch } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_MELTERMSOFUSE } from '../hooks/queries';

function renderBody(blocks) {
  return blocks
    .map((block) => {
      if (block.type === 'paragraph') {
        const text = block.children.map((child) => child.text).join('');
        return `<p>${text}</p>`;
      }
      return '';
    })
    .join('');
}


const term = ref(null);

// Run GraphQL query
const { result, loading, error } = useQuery(GET_MELTERMSOFUSE);

watch(result, (newResult) => {
  const firstItem = newResult?.meltermsofuses?.data?.[0];
  if (firstItem && firstItem.attributes) {
    term.value = firstItem.attributes;
  }
});

</script>

<template>
  <div class="container py-5">
     <!-- Breadcrumb -->
     <b-breadcrumb class="mb-3 mt-2">
      <b-breadcrumb-item href="/">
        <i class="fa fa-home" aria-hidden="true"></i> Home
      </b-breadcrumb-item>     
    </b-breadcrumb>
    <div class="card shadow-sm">
      <div class="card-body">
        <template v-if="loading">
          <div class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3">Loading term of use...</p>
          </div>
        </template>

        <template v-else-if="error">
          <div class="alert alert-danger" role="alert">
            Error loading terms of use. Please try again later.
          </div>
        </template>

        <template v-else-if="term">
          <h3 class="mb-3">{{ term.title }}</h3>
          <p><strong>Effective Date:</strong> {{ term.effectivedate }}</p>

          <hr />

          <div v-for="(section, index) in term.sections" :key="index" class="mb-4">
            <h5 class="text-primary">{{ section.heading }}</h5>
            <div v-html="renderBody(section.body)" class="text-body"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

